import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { useGetAllScorecardDisputesQuery } from './disputesSlice';
import './disputes.scss'
import { exportExcel, getValue } from './disputes-service';
import { DisputeDetails } from './DisputeDetails';

interface DisputesProps {
    inputYear: number;
    inputMonth: number;
    inputScorecardVersionId: number;
    scorecardVersionIdFromDisputes?: number;
}

export const Disputes = ({ inputYear, inputMonth, inputScorecardVersionId, scorecardVersionIdFromDisputes }: DisputesProps) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const { data: scorecardDisputesList } = useGetAllScorecardDisputesQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: scorecardVersionIdFromDisputes !== undefined ? scorecardVersionIdFromDisputes : inputScorecardVersionId
        },
        { skip: !inputYear || !inputMonth || (!inputScorecardVersionId && !scorecardVersionIdFromDisputes) }
    );

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <DisputeDetails disputeDetails={rowData} />
            </div>
        );
    };
    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-arrow-up me-2"
                    className="btn-export mr-2 me-2 float-end"
                    onClick={() => {
                        exportExcel(scorecardDisputesList?.data);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export Disputes
                </Button>
            </div>
        );
    };
    const header = renderHeader();
    return (
        <div className="card mt-3 ms-0 me-0 bg-body border-0">
            { !scorecardDisputesList || scorecardDisputesList?.data?.length === 0 ? (
                <div className='ms-2 ps-2'>
                No disputes found.
            </div>
            ) : (
                <>
            <div className='ms-2'>
                Scorecard: {scorecardDisputesList?.data[0]?.scorecardName}
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={scorecardDisputesList?.data}
                    header={header}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    className="scorecardDisputes"
                    rows={5}
                    paginator={scorecardDisputesList?.data?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                >
                    <Column
                        header="Employee Name"
                        field="employeeName"
                        headerStyle={{ fontSize: 14, minWidth: '25rem' }}
                        bodyStyle={{ minWidth: '25rem' }}
                        sortable
                        sortField="employeeName"
                    />
                    <Column
                        header="Role"
                        field="scorecardRole"
                        headerStyle={{ fontSize: 14, minWidth: '5rem' }}
                        bodyStyle={{ minWidth: '5rem' }}
                        sortable
                        sortField="scorecardRole"
                    />
                    <Column
                        header="Scorecard Name"
                        field="scorecardName"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="scorecardName"
                    />
                    <Column
                        header="Create Date"
                        field="disputeCreatedDate"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="disputeCreatedDate"
                    />
                    <Column
                        header="Resolved Date"
                        field="resolutionDate"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="resolutionDate"
                        body={(rowData: any) => getValue(rowData.resolutionDate)}
                    />
                    <Column
                        header="Dispute Reason"
                        field="disputeReason"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="disputeReason"
                    />
                    <Column
                        header="Dispute Type"
                        field="disputeType"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="disputeType"
                    />
                    <Column
                        header="Dispute Status"
                        field="disputeStatus"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="disputeStatus"
                    />
                    <Column
                        key="expand"
                        expander={allowExpansion}
                        style={{ width: '4em', marginRight: '10px' }}
                    />
                </DataTable>
            </div>
            </>
            )}
        </div>

    );
};
